<div class="search-select" (clickOutside)="onBlur()" clickOutside>
    <div class="search-select-input">
        <input type="text" class="form-control" [placeholder]="'Search' | translate" (focus)="onFocus()" (keyup)="onKeyUp($event)">
        <div class="selected-items" *ngIf="selectedOptions.length > 0">
            <div class="selected-item" *ngFor="let option of selectedOptions">
                <div class="selected-item-name">
                    {{option.label}}
                </div>
                <div class="selected-item-icon" (click)="onDeselect(option)">
                    <i class="fa fa-xmark"></i>
                </div>
            </div>
        </div>
        <div class="recommendations-list" *ngIf="isFocused">
            <div class="recommendation-item" *ngFor="let option of options" (click)="onOptionClick(option)">
                <div class="recommendation-item-icon">
                    <i class="fa fa-user"></i>
                </div>
                <div class="recommendation-item-name">
                    <span class="recommendation-item-name-text">
                        {{option.label}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
